import { instance } from "../axios";

export const upsertSampleShipmentReception = async (sampleShipmentId, body) => {
  const response = await instance.put(
    `/sampleshipmentreception/shipment/${sampleShipmentId}`,
    body,
  );
  return response.data;
};

export const deleteSampleShipmentReception = async (sampleShipmentId) => {
  await instance.delete(`/sampleshipmentreception/shipment/${sampleShipmentId}`);
};
